// Scroll-Reveal wie auf der Waitlist (Framer-Motion fadeUp + stagger in
// components/landing/PageSections.tsx): Elemente steigen 36px auf und blenden
// ein, sobald sie ins Bild scrollen — einmalig, mit 80px Vorlauf.
//
// Progressive Enhancement: die versteckenden Regeln haengen an der Klasse
// `lucid-reveal-ready`, die dieses Script setzt. Ohne JS (oder wenn das Script
// scheitert) bleibt alles sichtbar — Inhalt geht nie verloren.

(() => {
  const root = document.documentElement;

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.classList.add('lucid-reveal-ready');

  const reveal = (el, index) => {
    // Staffelung wie die Waitlist (0.13s je Geschwisterelement), begrenzt damit
    // spaete Elemente einer langen Gruppe nicht sichtbar hinterherhinken.
    el.style.transitionDelay = `${Math.min(index, 5) * 0.13}s`;
    el.classList.add('is-visible');
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const el = entry.target;
        const siblings = el.parentElement
          ? [...el.parentElement.querySelectorAll(':scope > .lucid-reveal')]
          : [el];
        reveal(el, siblings.indexOf(el));
        observer.unobserve(el);
      }
    },
    { rootMargin: '0px 0px -80px 0px' }
  );

  const observeAll = (scope) => {
    for (const el of scope.querySelectorAll('.lucid-reveal:not(.is-visible)')) {
      observer.observe(el);
    }
  };

  observeAll(document);

  // Der Theme-Editor rendert Sections nach dem Laden neu; frische Knoten
  // muessen erneut beobachtet werden, sonst blieben sie unsichtbar.
  document.addEventListener('shopify:section:load', (event) => observeAll(event.target));

  // Failsafe: sollte der Observer aus irgendeinem Grund nicht feuern (seltene
  // Browser-Eigenheit), wird nach 3s alles sichtbar gemacht — Inhalt darf nie
  // dauerhaft ausgeblendet bleiben.
  setTimeout(() => {
    for (const el of document.querySelectorAll('.lucid-reveal:not(.is-visible)')) {
      el.classList.add('is-visible');
    }
  }, 3000);
})();
